<mat-toolbar color="primary" class="apearAnimation flex-row flex content-between relative rounded-md">
  <span class="font-semibold">Administrador de horarios</span>

  <div class="absolute right-0 content-center">
    <ul class="flex-row flex content-center gap-2">
      <li>
        <button mat-icon-button (click)="openDialogCreate()">
          <mat-icon>add</mat-icon>
        </button>
      </li>
    </ul>
  </div>
</mat-toolbar>

<div class="margin-container apearAnimation">
  <!-- <app-tableusr></app-tableusr> -->

  <div class="flex flex-wrap items-baseline bg-stone-100 rounded-md pt-3 px-1 mb-2">
    <mat-form-field appearance="outline" class="w-full md:w-auto">
      <mat-label>Nombre del horario</mat-label>
      <input
        matInput
        type="text"
        [(ngModel)]="searchString"
        (keyup.enter)="onEnter()"
      />
      <button
        *ngIf="searchString"
        matSuffix
        mat-icon-button
        aria-label="Clear"
        (click)="searchString = ''"
      >
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>

    <mat-form-field appearance="outline" 
      class="example-full-width"
      style="padding-left: 10px; font-size: smaller"
    >
      <mat-label>Club</mat-label>
      <mat-select
        [(ngModel)]="clubSelect"
        (selectionChange)="cambioClubBuscar()"
      >
        <mat-option *ngFor="let clubTmp of lstClubes" [value]="clubTmp.id">
          {{ clubTmp.nombre }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" 
      class="example-full-width"
      style="padding-left: 10px; font-size: smaller"
    >
      <mat-label>Disciplina</mat-label>
      <mat-select
        [(ngModel)]="disciplinaSelect"
        (selectionChange)="cambioDiscipinaBuscar()"
      >
        <mat-option> Todas las disciplinas</mat-option>
        <mat-option
          *ngFor="let disciplinaTmp of lstDisciplinas"
          [value]="disciplinaTmp.id"
        >
          {{ disciplinaTmp.nombre }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" 
      class="example-full-width"
      style="padding-left: 10px; font-size: smaller"
    >
      <mat-label>Piscina</mat-label>
      <mat-select
        [(ngModel)]="piscinaSelect"
        (selectionChange)="cambioPiscinaBuscar()"
      >
        <mat-option value="-1" selected> Todas </mat-option>
        <mat-option value="0"> 50 mts </mat-option>
        <mat-option value="1"> Clavados </mat-option>
        <mat-option value="2"> Rugby </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="loading-indicator" *ngIf="isLoadingResults">
    <mat-spinner></mat-spinner>
  </div>

  <mat-form-field appearance="outline" >
    <mat-label>Filtro</mat-label>
    <input matInput (keyup)="applyFilter($event)" placeholder="Filtro" #input />
  </mat-form-field>

  <div class="mat-elevation-z0 contenedorTabla" *ngIf="!isLoadingResults">
    <table mat-table [dataSource]="dataSource">
      <!--       <ng-container matColumnDef="id">
              <th mat-header-cell *matHeaderCellDef>No.</th>
              <td mat-cell *matCellDef="let element">{{ element.id }}</td>
            </ng-container> -->

      <ng-container matColumnDef="empresa">
        <th mat-header-cell *matHeaderCellDef>Club</th>
        <td mat-cell *matCellDef="let element">{{ element.empresa }}</td>
      </ng-container>

      <ng-container matColumnDef="nombre">
        <th mat-header-cell *matHeaderCellDef>Nombre</th>
        <td mat-cell *matCellDef="let element">{{ element.nombre }}</td>
      </ng-container>

      <ng-container matColumnDef="disciplina">
        <th mat-header-cell *matHeaderCellDef>Disciplina</th>
        <td mat-cell *matCellDef="let element">{{ element.disciplina }}</td>
      </ng-container>

      <ng-container matColumnDef="dias">
        <th mat-header-cell *matHeaderCellDef>Días</th>
        <td mat-cell *matCellDef="let element">
          <label *ngIf="element.lunes">lunes </label>
          <label *ngIf="element.martes">martes </label>
          <label *ngIf="element.miercoles">miercoles </label>
          <label *ngIf="element.jueves">jueves </label>
          <label *ngIf="element.viernes">viernes </label>
          <label *ngIf="element.sabado">sabado </label>
          <label *ngIf="element.domingo">domingo </label>
        </td>
      </ng-container>

      <ng-container matColumnDef="piscina">
        <th mat-header-cell *matHeaderCellDef>Piscina</th>
        <td mat-cell *matCellDef="let element">
          <span *ngIf="element.piscina == 0">50 mts </span>
          <span *ngIf="element.piscina == 1">Clavados </span>
          <span *ngIf="element.piscina == 2">Rugby </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="horaInicio">
        <th mat-header-cell *matHeaderCellDef>Hora Inicio</th>
        <!-- <td mat-cell *matCellDef="let element">{{ element.horaInicio.hours }}:{{ element.horaInicio.minutes }}</td> -->
        <td mat-cell *matCellDef="let element">{{ element.horaInicio }}</td>
      </ng-container>

      <ng-container matColumnDef="horaFin">
        <th mat-header-cell *matHeaderCellDef>Hora Fin</th>
        <td mat-cell *matCellDef="let element">{{ element.horaFin }}</td>
      </ng-container>

      <ng-container matColumnDef="habilitado">
        <th mat-header-cell *matHeaderCellDef>Estado</th>
        <td mat-cell *matCellDef="let element">
          <mat-slide-toggle
            [checked]="element.habilitado"
            (change)="onToggle($event, element)"
          ></mat-slide-toggle>
        </td>
      </ng-container>

      <ng-container matColumnDef="botones">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">
          <button
            color="accent"
            mat-icon-button
            aria-label="Edit"
            (click)="edit(element)"
          >
            <mat-icon>edit</mat-icon>
          </button>

          <button
            mat-icon-button
            color="warn"
            aria-label="Delete"
            mat-icon-button
            aria-label="Delete"
            (click)="delete(element)"
          >
            <mat-icon>delete</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>

    <mat-paginator
      #paginator
      [length]="length"
      [pageIndex]="pageIndex"
      [pageSize]="pageSize"
      [pageSizeOptions]="[100, 150, 200, 500]"
      (page)="getServerData($event)"
    ></mat-paginator>
  </div>
</div>
